/* eslint-disable */
import React from 'react';

const ResourcesLogo = ({ fill, className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className}  width={16} height={16} viewBox="0 -960 960 960"
       fill={fill || "#FFFFFF"}>
    <path
      d="M378.46-440h347.69l-110.3-146.15-98.16 123.07-63.54-75.38L378.46-440ZM144.62-169.23q-26.85 0-45.74-18.89Q80-207 80-233.85v-443.07h40v443.07q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92H760v40H144.62Zm120-120q-26.85 0-45.74-18.89Q200-327 200-353.85v-421.53q0-26.85 18.88-45.74Q237.77-840 264.62-840h198.46l80 80h272.3q26.85 0 45.74 18.88Q880-722.23 880-695.38v341.53q0 26.85-18.88 45.73-18.89 18.89-45.74 18.89H264.62Zm0-40h550.76q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-341.53q0-10.77-6.92-17.7-6.93-6.92-17.7-6.92H527l-80-80H264.62q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7v421.53q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92Zm-24.62 0V-800v470.77Z" />
  </svg>
);

export default ResourcesLogo;
